export function getNextSectionVisibility(section, checked, showSales, showExpenses) {
  const nextValue = checked === true;

  if (section === "sales") {
    if (!nextValue && !showExpenses) {
      return { showSales, showExpenses };
    }

    return { showSales: nextValue, showExpenses };
  }

  if (!nextValue && !showSales) {
    return { showSales, showExpenses };
  }

  return { showSales, showExpenses: nextValue };
}

export function groupRecordsByDate(records) {
  const grouped = new Map();

  records.forEach((record) => {
    const existing = grouped.get(record.date) || [];
    existing.push(record);
    grouped.set(record.date, existing);
  });

  return grouped;
}

export function getVisibleDayRecords(records, isExpanded, limit) {
  return isExpanded ? records : records.slice(0, limit);
}
